import React, { Suspense } from 'react';
import './Footer.sass';
import Button from './../button/Button';
import SmallText from './../smallText/Smalltext';
import swonkieLogo from './../../../resources/icons/swonkieLogo/swonkieBlack.svg';
import facebookIcon from './../../../resources/icons/logos/facebookIcon.svg';
import instagramIcon from './../../../resources/icons/logos/instagramIcon.svg';
import linkedinIcon from './../../../resources/icons/logos/linkedinIcon.svg';
import twitterIcon from './../../../resources/icons/logos/twitterIcon.svg';
import norte2020 from './../../../resources/icons/logos/norte2020.webp';
import portugal2020 from './../../../resources/icons/logos/portugal2020.webp';
import uniaoEuropeia from './../../../resources/icons/logos/uniaoEuropeia.webp';
import i18n from '../../../i18n';
import Config from '../../../base/config/Config';
import Cookies from 'js-cookie';
import { Link } from 'react-router-dom';
import DataArray from '../../../base/config/DataArray';
import NewArea from '../newArea/NewArea';
import Utils from '../../../base/Utils';
import brinferLogo from './../../../resources/icons/brinfer_white.svg';

const Footer = React.memo(props => {
    var { path } = props;
    var solutions = DataArray.categories;
    var company = DataArray.company;
    var resources = DataArray.resources;
    var currentLanguage = Cookies.get('currentLanguage');

    var urlPath = path || '';

    var startText = urlPath.indexOf('/') + 1;
    var endText = urlPath.indexOf('/', startText);
    var text_to_get = urlPath.substring(startText, endText);

    urlPath = urlPath.replace(`/${text_to_get}/`, '/');

    if (typeof Config.langFiles[urlPath.split('/').join('')] !== 'undefined') {
        urlPath = '/';
    }

    var date = new Date();
    var year = date.getFullYear();

    var html = <footer className="Footer" >
        <div className="FooterTop">
            <div className="FooterLogo">
                <div className="FooterLogoImage">
                    <Link to="/"> <img src={swonkieLogo} alt="swonkieLogo" /> </Link>
                </div>
                <div className="FooterLogoText">
                    <SmallText size="Big" font="SofiaProRegular" text={'Copyright ©' + year + ' Swonkie'} />
                    <div className="FooterLogoTextLinks">
                        <Link to={`/${currentLanguage}/privacy-policy`} > <SmallText size="Big" font="SofiaProRegular" text={`| ${i18n.t('privacy')}`} /> </Link>
                        <Link to={`/${currentLanguage}/terms-conditions`} > <SmallText size="Big" font="SofiaProRegular" text={`| ${i18n.t('Terms')}`} /> </Link>
                        <a href="javascript:window.cookieconsent.openPreferencesCenter()" > <SmallText size="Big" font="SofiaProRegular" text={`| ${i18n.t('Cookie Preferences')}`} /> </a>
                    </div>

                    <a href={'mailto:' + Config.email} target="_blank" rel="noopener noreferrer"> <SmallText size="Big" font="SofiaProRegular" text={Config.email} />  </a>
                    <SmallText size="Big" font="SofiaProRegular" text={Config.location} />
                </div>
                <div className="FooterLogoMedia">
                    <a href="https://www.facebook.com/Swonkie/" target="_blank" rel="noopener noreferrer"> <img src={facebookIcon} alt="facebookIcon" /> </a>
                    <a href="https://www.instagram.com/swonkie/" target="_blank" rel="noopener noreferrer"> <img src={instagramIcon} alt="instagramIcon" /> </a>
                    <a href="https://www.linkedin.com/company/swonkie/" target="_blank" rel="noopener noreferrer"> <img src={linkedinIcon} alt="linkedinIcon" /> </a>
                    <a href="https://twitter.com/swonkieofficial" target="_blank" rel="noopener noreferrer"> <img src={twitterIcon} alt="twitterIcon" /> </a>
                </div>
            </div>
            <div className='FooterTopRightArea'>
                <div className="FooterButtonsArea">
                    <div className="FooterButtonsText">
                        <SmallText size="Big" font="SofiaProBold" text={i18n.t('Solutions')} />
                    </div>
                    {solutions.map((solutions, key) => {
                        return <Link style={{ display: 'flex' }} key={key} to={`/${currentLanguage}/solutions/${solutions.href}`}> <Button key={key} size="Small" type="Footer" text={<><span style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{solutions.text}</span> {solutions.isNew && <NewArea type='Andie' style={{ marginLeft: '4px' }} />}</>} /> </Link>;
                    })}
                </div>
                <div className="FooterButtonsArea">
                    <div className="FooterButtonsText">
                        <SmallText size="Big" font="SofiaProBold" text={company.title} />
                    </div>
                    {company.buttons.map((company, key) => {
                        if (company.text === 'Blog')
                            return <a key={key} href={company.to} target="_blank" rel="noopener noreferrer"> <Button key={key} size="Small" type="Footer" text={company.text} /> </a>;
                        else if (company.text.includes('2020'))
                            return <a key={key} href={company.to} target="_blank" rel="noopener noreferrer"> <Button key={key} size="Small" type="Footer" text={company.text} /> </a>;
                        else
                            return <Link key={key} to={`/${currentLanguage}/${company.to}`}> <Button key={key} size="Small" type="Footer" text={company.text} /> </Link>;
                    })}
                </div>
                <div className="FooterButtonsArea">
                    <div className="FooterButtonsText">
                        <SmallText size="Big" font="SofiaProBold" text={resources.title} />
                    </div>
                    {resources.buttons.map((resource, key) => {
                        if (resource.to.includes('http'))
                            return <a key={key} href={resource.to} target="_blank" rel="noopener noreferrer"> <Button size="Small" type="Footer" text={resource.text} /> </a>;
                        else
                            return <Link key={key} to={`/${currentLanguage}/${resource.to}`}> <Button size="Small" type="Footer" text={resource.text} /> </Link>;
                    })}
                </div>
                <div className="FooterButtonsArea">
                    <div className='FooterBrinferArea'>
                        <img src={brinferLogo} style={{ marginBottom: '26px', height: '20px' }} />
                        <SmallText color='Primary' size='colossal' type='SofiaProBold' text={i18n.t('Find the right influencers for your business.')} />
                        <Button onClick={() => Utils.redirect('https://brinfer.com/' + (currentLanguage.includes('en') ? 'en' : 'pt') + '/?utm_source=swonkie_brinfer&utm_medium=homepagerodape&utm_campaign=swonkie_homepage_rodape', '_blank')} text={i18n.t('Find Influencers').toUpperCase()} />
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div className="FooterLanguageButton"> <a href={`${Config.host}pt${urlPath}`}> <Button type="Transparentfourth" size="Small" text="PT" /> </a> | <a href={`${Config.host}en${urlPath}`}> <Button type="Transparentfourth" size="Small" text="EN" /> </a> | <a href={`${Config.host}es${urlPath}`}> <Button type="Transparentfourth" size="Small" text="ES" />  </a>| <a href={`${Config.host}pt-br${urlPath}`}> <Button type="Transparentfourth" size="Small" text="PT-BR" /> </a>| <a href={`${Config.host}fr${urlPath}`}> <Button type="Transparentfourth" size="Small" text="FR" /> </a> </div>
        </div>
        <div className="footerBottom">
            <Link to="/2020" target="_blank" rel="noopener noreferrer" >
                <img src={norte2020} alt="norte2020" />
                <img src={portugal2020} alt="portugal2020" />
                <img src={uniaoEuropeia} alt="uniaoEuropeia" />
            </Link>
        </div>
    </footer>;

    return <Suspense fallback={null}>{html}</Suspense>;
});

export default Footer;
